import React from 'react';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';

import ReactLoading from 'react-loading';
import { updateCookieList } from '../../api/Shortcuts';
import Txt from '../atoms/Txt';
import { useGetUser } from '../../database/repositories/UserRepository';
import { normalizeMoney } from '../../utils/util';

const Container = styled.a`
  margin-bottom: 50px;
  width: 320px;

  &:link {
    text-decoration: none;
  }
`;

const UpperSection = styled.div`
  width: 320px;
  height: 320px;
  overflow: hidden;
  background: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 5px;
  }
`;

const MiddleSection = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;

  h1 {
    color: #002666;
    font-size: 20px;
    font-weight: bold;
  }

  li {
    color: #86c232;
    margin: 0;
    padding: 0;
    font-size: 16px;
    position: relative;
    right: 20px;
    bottom: 5px;
    font-weight: bold;
    list-style-type: disc;
  }
`;

const LowerSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  p {
    margin: 0;
  }

  strong {
    color: #002666;
    font-size: 18px;
    margin-top: 5px;
    display: block;
    text-align: right;
  }

  .product-card-when-info {
    color: #949494;
    font-size: 16px;
    margin-top: 5px;
  }
`;

const PriceButton = styled.div`
  background: #ffb615;
  border-radius: 5px;
  padding: 5px 15px;

  p {
    color: #fff;
    font-size: 28px;
    font-weight: bold;

    span {
      font-size: 8px;
    }
  }
`;

function ProductCard({ productData, color }) {
  const [seller, sellerLoading] = useGetUser(productData.seller);
  const [cookie, setCookie] = useCookies(['productsBrowseHistory']);

  return (
    <Container
      href={`/produto/detalhes/${productData.id}`}
      onClick={() => {
        setCookie('productsBrowseHistory', updateCookieList(cookie, productData.id), {
          path: '/'
        });
      }}>
      <UpperSection>
        {/* {productData ? (
            <Carousel
              style={{ color: 'red' }}
              interval={null}>
              {productData.pictures.map((pictures) =>
                <Carousel.Item>
                  <img className="d-block w-100" src={pictures ? pictures : null} alt=" Carregando..." />
                </Carousel.Item>
                )}
            </Carousel>
          ) : null} */}
        <img
          style={{
            width: '100%',
            height: 'auto'
          }}
          src={productData.pictures[0]}
          alt="Foto do Produto"
        />
      </UpperSection>
      <MiddleSection>
        <Txt size={20} color={color} bold p>
          {productData.name}
        </Txt>
        <Txt size={16} color="#86c232" bold>
          {' '}
          &#8226; Anunciante online
        </Txt>
      </MiddleSection>
      <LowerSection>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {!sellerLoading ? (
            <Txt bold color="#949494" size={12}>
              {seller
                ? `${seller?.addresses[0].city} / ${seller.addresses[0].state}`
                : // TEMPORARIO
                  'Endereço não encontrado'}
            </Txt>
          ) : (
            <ReactLoading type="cubes" color="#949494" height={20} width={15} />
          )}
          <Txt size={16} color="#ffb615" style={{ textDecoration: 'underline' }}>
            {productData.department}
          </Txt>
          <Txt size={16} color="#949494" style={{ marginTop: 10 }}>
            {productData ? new Date(productData.addedDate).toLocaleDateString('pt-br') : null}
          </Txt>
        </div>
        <div>
          <PriceButton>
            {/* <p>R$ 170<span>,95</span></p> TODO: quebrar preço na vírgula/ponto e replicar este efeito */}
            <Txt color="white" size={20} bold>
              {normalizeMoney(productData.price)}
            </Txt>
          </PriceButton>
          <strong>10x {normalizeMoney(productData.price / 10)}</strong>
        </div>
      </LowerSection>
    </Container>
  );
}

export default ProductCard;
